import { render } from "./HomeworkDetail.vue?vue&type=template&id=1f4d226d&scoped=true"
import script from "./HomeworkDetail.vue?vue&type=script&lang=js"
export * from "./HomeworkDetail.vue?vue&type=script&lang=js"

import "./HomeworkDetail.vue?vue&type=style&index=0&id=1f4d226d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4d226d"]])

export default __exports__